/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailInseam_item = {|
  +measurement: ?{|
    +inseam: ?$ReadOnlyArray<?{| |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailInseam_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "inseam",
          "args": [
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "inseam"
              ],
              "type": "[measurementFieldType]"
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailMeasurement_measurements",
              "args": null
            }
          ],
          "storageKey": "display{\"fields\":[\"inseam\"]}"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
